// First, so it reads the referrer and campaign tags before anything changes the address
import './track';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import reportWebVitals from './reportWebVitals';
import { trackVital } from './track';
import './index.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
// Brand fonts (see theme.js), bundled so they're identical on every device
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// Core Web Vitals by page, for the admin portal's Traffic page (track.js)
reportWebVitals(trackVital);
